import { Component, Input, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Company } from '../../../models/company.model';

/**
 * This component shows a button that opens the modal that lists the
 * certificates of a {@link Company}.
 * ## Usage
 * ``` html
 * <certificates-button
 * [company]="company"></certificates-button>
 * ```
 * ### Related UI components:
 * - [[CompanyInfoComponent]]
 */
@Component({
  selector: 'certificates-button[company]', // company is a required attribute
  templateUrl: './certificates-button.component.html',
  styleUrls: ['./certificates-button.component.scss']
})
export class CertificatesButtonComponent implements OnDestroy {

  @ViewChild('certificateTable', { static: true }) private readonly certificateTable: TemplateRef<any>;

  @Input() public company: Company;

  private modalRef: BsModalRef;
  private destroy$ = new Subject<void>();

  /** @ignore */
  constructor(
    private modalService: BsModalService
  ) { }

  public show(): void {
    this.openModal(this.certificateTable, 'modal-lg');
  }

  /** Generic Modal trigger. */
  private openModal(template: TemplateRef<any>, c: string = ''): void {
    this.modalRef = this.modalService.show(template, { class: c });

    // this.modalSub = this.modalRef.onHide.subscribe((reason: string) => {
    //   this.modalSub.unsubscribe();
    //   this.modalRef = undefined;
    //   // Reset all values
    //   this.processing = false;
    // });
  }

  /** Closes the most recent opened modal. */
  public closeModal(onHide: Function = null): void {
    if (this.modalRef) {
      this.modalRef.hide();
      if (onHide) {
        this.modalRef.onHide
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => onHide());
      }
    } else {
      if (onHide) onHide();
    }
  }

  /** @ignore */
  ngOnDestroy(): void {
    // Complete all subscriptions using takeUntil pattern
    this.destroy$.next();
    this.destroy$.complete();

    // Close any open modals
    this.closeModal();
  }
}
